import React, { useEffect, useMemo, useState } from 'react';
import classNames from 'classnames';
import CustomButton from '../../../features/customButton/ui/main/CustomButton';
import { safeHTML } from '../../../../utils/safeHTML';
import { CSSTransition } from 'react-transition-group';
import { useModal } from '../../../../hooks/useModal';
import { nyTaskContent } from '../../../../constants/copyright';

const { afterAnswerModal } = nyTaskContent;

const QuizGuessForm = React.forwardRef(function QuizGuessForm(
  { answers: answersData, image, note_title, note_image, text, note, setScore, nextStep },
  ref,
) {
  const [answers, setAnswers] = useState(() => toFormattedState(answersData));
  const [isVisibleNoteImage, setIsVisibleNoteImage] = useState(false);
  const [isTransition, seIsTransition] = useState(false);
  const { addModal } = useModal();

  const isDisabled = useMemo(() => answers?.every(({ isActive }) => !isActive), [answers]);

  const setActive = (id) => {
    if (isVisibleNoteImage) return;

    setAnswers((prev) => {
      return prev.map((answer) => ({
        ...answer,
        isActive: id === answer.id,
      }));
    });
  };

  const submit = () => {
    const activeAnswer = answers.find(({ isActive }) => isActive);
    if (activeAnswer) setIsVisibleNoteImage(true);
  };

  useEffect(() => {
    if (!isTransition) return;

    const timeoutId = setTimeout(() => {
      const isActive = answers.find(({ isActive }) => isActive)?.id;

      const successCallback = () => {
        setScore(isActive);
        nextStep();
        setIsVisibleNoteImage(false);
        seIsTransition(false);
      };

      addModal({
        type: 'quizStartModal',
        props: {
          ...afterAnswerModal,
          image: note_image,
          title: note_title,
          description: note,
          goToQuiz: successCallback,
          onClose: successCallback,
        },
      });
    }, 2000);

    return () => clearTimeout(timeoutId);
  }, [answers, isTransition]);

  return (
    <div className={`quiz__item quiz__item_simple`}>
      <div className={'quiz__item-image quiz__item-image_guess'}>
        <img src={image} alt={'quiz-guess-form-image'} />
        <CSSTransition
          in={isVisibleNoteImage}
          timeout={700}
          classNames={'quiz__image-note'}
          onEntered={() => seIsTransition(true)}
        >
          <img src={note_image} className={'quiz__image-note'} alt={'quiz-guess-form-image'} />
        </CSSTransition>
      </div>
      <div className={'quiz__item-block'}>
        <h2 className='quiz__item-title'>
          <span>{safeHTML(text)}</span>
        </h2>
        <div className={`quiz__item-items`}>
          <ul>
            {answers?.map(({ text, id, isActive }) => (
              <li key={`li-${id}`}>
                <CustomButton
                  className={classNames('custom-button_quiz-item quiz__item-option', {
                    'quiz__item-option_active': isActive,
                  })}
                  text={text}
                  onClick={() => setActive(id)}
                />
              </li>
            ))}
          </ul>
        </div>
        <CustomButton
          className={classNames('button_quiz-a quiz__item-button')}
          text={'other.reply'}
          disposable={true}
          disabled={isVisibleNoteImage || isDisabled}
          onClick={submit}
        />
      </div>
    </div>
  );
});

function toFormattedState(answers) {
  return answers.map((answer) => ({ ...answer, isActive: false }));
}

export default QuizGuessForm;

QuizGuessForm.propTypes = {};
